import React, { } from "react";
import ReportPage from './reportPage/reportPage.Container';
/* Package JSON Import will be here */

/* Project Import will be here */
import Layout from '../../comman/Layout/Layout';
/* Project Import will be here */

/* Styles will be here */
// import './sales.css';
/* Styles will be here */

/* Const,Let & Var will be here */
// const Search = Input.Search;
/* Const,Let & Var will be here */

const ReportComponent = props => {
    return (
        <Layout>
            { props.report.isReportClicked && <ReportPage /> }
        </Layout>
    );
}

export default ReportComponent;

ReportComponent.displayName = "ReportComponent";